import { combineReducers } from 'redux';
import projectsInfo from './projects/reducer.projects';
import errors from './errors/reducer.errors';
import user from './user/reducer.user';
import microphone from './microphone/reducer.microphone';
import scriptEditor from './scriptEditor/reducer.scriptEditor';
import diffMode from './diffMode/reducer.diffMode';
import testMode from './testMode/reducer.testMode';
import mobileSpecificBehaviour from './mobileSpecificBehaviour/reducer.mobileSpecificBehaviour';
import codeMetaData from './codeMetaData/reducer.codeMetaData';
import config from './config/reducer.config';
import gitHubIntegration from './gitHubIntegration/reducer.gitHubIntegration';
import projectAnalytics from './projectAnalytics/reducer.projectAnalytics';
import predefinedScripts from './predefinedScripts/reducer.predefinedScripts';
import clientCodeRunner from './clientCodeRunner/reducer.clientCodeRunner';
import organization from './organization/reducer.organization';
import corpus from './corpus/reducer.corpus';
import * as userActionTypes from './user/actionTypes.user';

const mainReducer = combineReducers({
    projectsInfo,
    errors,
    user,
    microphone,
    scriptEditor,
    diffMode,
    testMode,
    mobileSpecificBehaviour,
    codeMetaData,
    gitHubIntegration,
    projectAnalytics,
    predefinedScripts,
    clientCodeRunner,
    config,
    organization,
    corpus
});

const rootReducer = (state, action) => {
    if (action.type === userActionTypes.USER_LOG_OUT) {
        state = {
            config: {
                features: state.config.features
            }
        };
    }

    return mainReducer(state, action);
};

export default rootReducer;
